import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { COMPONENTS } from './components';
import { GridComponent } from './components/grids';
import { GridHeaderComponent } from './components/assorted/grid-header.component';
import { AgGridModule } from 'ag-grid-angular/main';
import { LicenseManager } from 'ag-grid-enterprise/main';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PIPES } from './pipes';
import { AuthModule } from '~auth/auth.module';
import { ContactUsModalComponent } from './components/layout/contact-us-modal.component';
import { LearnMoreModalComponent } from './components/layout/learn-more-modal.component';
import { environment } from 'environments/environment.prod';
import { HighchartsChartModule } from 'highcharts-angular';
import { SERVICES } from './services';


LicenseManager.setLicenseKey(environment.agGridLicenseKey);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AgGridModule.withComponents([GridHeaderComponent]),
    NgbModule,
    AuthModule,
    HighchartsChartModule
  ],
  providers: [SERVICES],
  exports: [
    ...COMPONENTS,
    ...PIPES,
    CommonModule,
    FormsModule
  ],
  declarations: [...PIPES, ...COMPONENTS],
  entryComponents: [GridComponent, ContactUsModalComponent, LearnMoreModalComponent]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts